import { render, staticRenderFns } from "./Nif.vue?vue&type=template&id=137956a2&scoped=true&"
import script from "./Nif.vue?vue&type=script&lang=js&"
export * from "./Nif.vue?vue&type=script&lang=js&"
import style0 from "./Nif.vue?vue&type=style&index=0&id=137956a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137956a2",
  null
  
)

export default component.exports